"use client"

import React from "react";
import {FaBars, FaTimesCircle} from "react-icons/fa";
import * as Link from "next/link"
import MenuItems from "./Mobile/MenuItems";

import SubMenuItem from "./SubMenuItem";
import CTA from "../Landing/valueprop/CTA";


export default function Navbar({siteConfig, cta, baseUrl = "/"}) {
    const [isOpen, setIsOpen] = React.useState(false);
    const {logo, altLogo} = siteConfig

    const menuItems = siteConfig?.menuConfig

    if (!menuItems) {
        return null;
    }

    return (
        <header className="header-1">
            <div className="container">
                <div className="row align-items-center justify-content-between">
                    <div className="col-lg-2 col-sm-5 col-md-4 col-6">
                        <div className="logo">
                            <Link href={baseUrl}>
                                <div style={{display: 'flex', alignItems: 'flex-start', flexDirection: 'column'}}>
                                    <img src={logo.url} alt={logo.alt} style={{width: 150}}/>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div
                        className="col-lg-10 text-end p-lg-0 d-none d-lg-flex justify-content-between align-items-center">
                        <div className="menu-wrap">
                            <div className="main-menu">
                                <ul key="desktop-menu">
                                    {menuItems.map((menuItem, index) => (
                                        <li key={`mn-key-${index}`}>
                                            <a href={menuItem.path || "#"}>{menuItem.title}</a>
                                            {menuItem.submenu &&
                                                <ul key={`sm-${menuItem.path}`} className="sub-menu">
                                                    {menuItem.submenu.map((subMenu) => (
                                                        <SubMenuItem id={subMenu.path}
                                                                     key={subMenu.path}
                                                                     title={subMenu.title}
                                                                     subTitle={subMenu.subTitle}
                                                                     to={subMenu.path}
                                                                     icon={subMenu.icon}/>
                                                    ))}
                                                </ul>
                                            }
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        {cta &&
                            <div className="header-right-element text-white">
                                <CTA cta={cta} siteConfig={siteConfig}/>
                            </div>
                        }

                    </div>
                    <div className="d-block d-lg-none col-sm-1 col-md-8 col-6">
                        <div className="mobile-nav-wrap">
                            <div id="hamburger" onClick={() => setIsOpen((prev) => !prev)}>
                                <FaBars/>
                            </div>

                            <div className={`mobile-nav ${isOpen ? "show" : ""}`}>
                                <button type="button" className="close-nav" onClick={() => setIsOpen((prev) => !prev)}>
                                    <FaTimesCircle/>
                                </button>
                                <nav className="sidebar-nav">
                                    <ul key="mobile-menu" className="metismenu" id="mobile-menu">
                                        {menuItems.map((menu, index) => (
                                            <MenuItems isOpenMenu={isOpen} key={index} items={menu}
                                                       onClose={() => setIsOpen(false)}/>
                                        ))}
                                    </ul>
                                    {cta && <div className="mt-30">
                                        <CTA cta={cta} siteConfig={siteConfig}/>
                                    </div>}
                                </nav>
                            </div>
                        </div>
                        <div
                            className={`overlay ${isOpen ? "active" : ""}`}
                            onClick={() => setIsOpen((prev) => !prev)}
                        ></div>
                    </div>
                </div>
            </div>

        </header>
    );
}
